<template>
  <div class="pa-3">
    <h1>Admin</h1>
    <v-tabs v-model="active" grow>
      <v-tab v-for="tab of tabs" :key="tab.id" @click="tabChanged(tab.id)">
        {{ tab.name }}
      </v-tab>
      <v-tab-item>
        <admin-resources></admin-resources> 
      </v-tab-item>
      <v-tab-item>
        <admin-users></admin-users> 
      </v-tab-item>
      <v-tab-item>
        <v-row>
          <v-col>
            <editable-container :editables="editables" :editing="editing" :bg-color-name.sync="bgColor" />
          </v-col>
        </v-row>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import AdminResources from  '@/components/AdminResources'
import AdminUsers from  '@/components/AdminUsers'
import EditableContainer from '@/components/core/EditableContainer.vue'

export default {
  data() {
    return {
      active: 0,
      tabs: [
        { id: 0, name: 'Resources' },
        { id: 1, name: 'Users' },
        { id: 2, name: 'Blog' },
      ],
      editing: false,
      editables: [
        {e:'editable',v:'<h1>Because Medium Sucks for Developers</h1><h3>(and, why I made Tipsy Coder)</h3>',noDelete:1,maxLength:200,classes:['heading']},
        {e:'editable',v:'I decided to do this because I like Medium, but the editor sucks__ especially for coders. There are a few things that make it near impossible to code blog on Medium...'},
        {e:'editable',v:'<ul><li>No alignment besides left</li><li>Hard to indent &amp; line-break code</li><li>Code area is too narrow</li><li>No line numbers</li></ul>'},
        {e:'editable',v:'<h1>Hello Developer</h1>\n<p>Welcome to TipsyCoder.</p>',mode:1,classes:['code-container'],maxLength:1000},
      ],
      bgColor: 'magenta'
    }
  },
  computed: {
    ...mapState({
      currentUser: state => state.user.currentUser
    }),
    formTitle () {
      return this.activeIndex === -1 ? 'New Snippet' : 'Edit Snippet'
    },
    activeTab() {
      return parseInt(this.$route.query.tab,10) || this.active
    },
    bg() {
      return this.bgColor
    }
  },
  components: {
    AdminResources,
    AdminUsers,
    EditableContainer
  },
  methods: {
    tabChanged(tab) {
      this.active = tab
      this.snippetSearch = ''
    }
  },
  watch: {
    //$route (to, from){
      //console.log(to, from)
    //}
  } 
}
</script>
